import * as React from "react";
import { SVGProps, memo } from "react";

const SvgVisa = (props: SVGProps<SVGSVGElement>) => (
  <svg width={44} height={30} fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      d="M41.037 29.672H2.677C1.248 29.672 0 28.435 0 27.022V2.65C0 1.236 1.249 0 2.676 0h38.36c1.428 0 2.677 1.236 2.677 2.65v24.373c0 1.412-1.249 2.649-2.676 2.649Z"
      fill="#fff"
    />

    <path
      d="m16.485 19.927 1.734-10.128h2.774L19.26 19.927h-2.774ZM29.316 10.143c-.52-.172-1.387-.344-2.6-.344-2.775 0-4.683 1.373-4.856 3.433 0 1.545 1.387 2.232 2.428 2.747 1.387.343 1.734.686 1.734 1.03 0 .686-.867 1.03-1.734 1.03-1.214 0-1.734-.172-2.601-.516l-.347-.171-.52 2.231c.693.344 1.907.515 3.12.515 2.949 0 4.856-1.373 4.856-3.433 0-1.201-.694-2.06-2.428-2.746-1.04-.515-1.56-.858-1.56-1.202 0-.343.52-.858 1.56-.858.867 0 1.561.172 2.081.343l.174.172.693-2.231ZM34.172 9.8c-.694 0-1.214.171-1.388.858l-4.161 9.269h2.948l.52-1.545h3.641l.347 1.545h2.601L36.426 9.799h-2.254Zm-1.214 6.522c.173-.515 1.214-2.918 1.214-2.918l.346-1.03.174.858s.52 2.403.693 2.918l-2.427.172ZM11.283 16.837l-.173-1.373c-.52-1.717-2.255-3.433-3.989-4.292l2.428 8.926h2.948l4.508-10.127h-2.948l-2.774 6.866Z"
      fill="#172E7D"
    />

    <path
      d="M4 9.8c3.468 1.03 6.069 3.089 6.936 5.664l-.867-4.806c-.173-.687-.694-.859-1.387-.859H4Z"
      fill="#F19519"
    />
  </svg>
);

const Memo = memo(SvgVisa);

export default Memo;
